<template>
    <div>
        <div>
            <div v-html="policy.document"></div>
        </div>

        <div class="agree">
            <input type="checkbox" name="confirm" id="confirm" class="confirm" @input="policyToggled(policy)" v-model="policy.accepted">
            <label for="confirm">{{ declarationText }}{{ policyName }}.</label>
        </div>
    </div>
</template>

<script>
    export default {
        props: [ 'declarationText', 'policy' ],
        methods: {
            policyToggled(policy) {
                policy.accepted = !policy.accepted;
                this.$emit('policyToggled', policy)
            }
        },
        computed: {
            policyName() {
                return (this.policy && this.policy.policyName === 'Default' ? '' : ' ' + this.policy.policyName);
            }
        }
    }
</script>
